import { GET_SERVICE_STATUS } from 'constants/actionTypes';
import api from 'api/appApi';

export const getServiceStatus = () => (dispatch) =>
  api.serviceStatus.getServiceStatus().then((res) => {
    dispatch({ type: GET_SERVICE_STATUS, payload: res.data });
  });
